import Toggle from '../plugins/tac-toggle';

declare const jQuery: any;

export default class Subscription {

    element: HTMLElement
    key: string
    id: string

    constructor(element: HTMLElement) {
        this.element = element;
        this.key = element.dataset.subscription;
        this.id = element.dataset.subscription_id;
    }

    register() {
        this.initAutoRenew();
        this.initLicenseSelection();
    }

    initAutoRenew() {
        const links = this.element.querySelectorAll<HTMLLinkElement>('[data-toggle="auto_renewal"]');

        for (const link of links) {
            new AutoRenewToggle(link, this.id, link.dataset.security);
        }
    }

    initLicenseSelection() {
        const element = this.element.querySelector('.subscription__info__license');

        element.addEventListener('click', function () {
            let range, selection;

            if (window.getSelection && document.createRange) {
                selection = window.getSelection();
                range = document.createRange();
                range.selectNodeContents(this);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        });
    }

}

class AutoRenewToggle {

    element: HTMLElement
    id: string
    security: any

    constructor(element: HTMLElement, subscription_id: string, security: string) {
        this.element = element;
        this.id = subscription_id;
        this.security = security;

        this.init();
    }

    init() {
        let toggle = new Toggle(this.element);

        toggle.onToggleOn(() => {
            this.toggle('enable');
        });

        toggle.onToggleOff(() => {
            this.toggle('disable');
        });
    }
 
    toggle(type: string) {
        const el = this.element;
        const action = `wcs_${type}_auto_renew`;

        jQuery.ajax(codepress.ajaxurl, {
            method: 'POST',
            data: {
                'action': action,
                'subscription_id': this.id,
                'security': this.security
            },
            success: function (response: any) {
                let method = el.closest('.subscription').querySelector('[data-payment-method]');
                if (method) {
                    method.innerHTML = response.payment_method;
                }

                let status = el.closest('.subscription').querySelector('[data-autorenewal_status]');
                if (status) {
                    status.innerHTML = (type === 'enable') ? 'Enabled' : 'Disabled';
                }

            }
        });
    }

}